// src/components/Header.js
import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 80,
        behavior: 'smooth'
      });
      setIsMenuOpen(false);
    }
  };

  return (
    <header style={styles.header}>
      <div style={styles.container}>
        <div style={styles.logoContainer}>
          <img
            src="/icono_app.png"
            alt="Quadramelo Logo"
            style={styles.logoIcon}
          />
          <Link to="/" style={styles.logoText}>
            Quadramelo
          </Link>
        </div>

        {isMobile ? (
          <>
            <button
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              style={styles.menuButton}
              aria-label="Toggle menu"
            >
              ☰
            </button>
            {isMenuOpen && (
              <nav style={styles.navMobile}>
                <button onClick={() => scrollToSection('about')} style={styles.navLinkMobile}>
                  ¿Quiénes somos?
                </button>
                <button onClick={() => scrollToSection('download')} style={styles.navLinkMobile}>
                  Descargar App
                </button>
              </nav>
            )}
          </>
        ) : (
          <nav style={styles.navDesktop}>
            <button onClick={() => scrollToSection('about')} style={styles.navLink}>
              ¿Quiénes somos?
            </button>
            <button onClick={() => scrollToSection('download')} style={styles.navLink}>
              Descargar App
            </button>
          </nav>
        )}
      </div>
    </header>
  );
};

const styles = {
  header: {
    backgroundColor: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
    boxShadow: '0 2px 20px rgba(0,0,0,0.08)',
    padding: '1rem 0',
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    transition: 'all 0.3s ease',
  },
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    maxWidth: '1200px',
    margin: '0 auto',
    padding: '0 1.5rem',
    position: 'relative',
  },
  logoContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.75rem',
  },
  logoIcon: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'contain',
    border: '2px solid #f0f0f0',
    boxShadow: '0 4px 12px rgba(0,0,0,0.08)',
    backgroundColor: '#fff',
    padding: '4px',
  },
  logoText: {
    fontSize: '1.8rem',
    fontWeight: '800',
    color: '#4361ee',
    textDecoration: 'none',
    fontFamily: "'Poppins', sans-serif",
  },
  navDesktop: {
    display: 'flex',
    gap: '1.5rem',
  },
  navLink: {
    background: 'transparent',
    border: 'none',
    color: '#495057',
    fontSize: '1.05rem',
    fontWeight: '600',
    cursor: 'pointer',
    padding: '0.5rem 0',
    transition: 'color 0.3s ease',
  },
  menuButton: {
    background: 'none',
    border: 'none',
    fontSize: '1.8rem',
    cursor: 'pointer',
    color: '#4361ee',
  },
  navMobile: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: 'white',
    boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
    padding: '1.5rem',
    display: 'flex',
    flexDirection: 'column',
    gap: '1.2rem',
  },
  navLinkMobile: {
    background: 'transparent',
    border: 'none',
    color: '#495057',
    fontSize: '1.2rem',
    fontWeight: '600',
    cursor: 'pointer',
    textAlign: 'left',
  },
};

export default Header;